import { BASE_FONT as t } from "../types/constants.js";
function f(e, o = t) {
  return Object.keys(e).reduce((n, r) => (n[r] = typeof n[r] == "string" && e[r].includes("rem") ? `${(e[r].replace("rem", "") * 16 / o).toFixed(2)}rem` : e[r], n), {});
}
export {
  f as tokenTransform
};
